export default __webpack_public_path__ + "static/media/flagIcon.f391767f.svg";